import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import LearnerLandingCCREnabled from '@pages/Landing/components/LearnerLandingCCREnabled';
import NonLearnerLandingCCREnabled from '@pages/Landing/components/NonLearnerLandingCCREnabled';
import NonLearnerLandingCCRDisabled from '@pages/Landing/components/NonLearnerLandingCCRDisabled';

import { PageLoader } from '@components/Layout';
import { ROUTES } from '@constants/routes';
import { isLearnerOrAlumni, useAuthStoreContext } from '@context/authStore';

export const Root = () => {
  const navigate = useNavigate();
  const { currentAccess, userData, isLoadingUser, isLoadingUserPreferences } = useAuthStoreContext();

  const isLearner = isLearnerOrAlumni(currentAccess.tenant?.permission?.role);
  const isCCREnabled = (currentAccess.tenant?.productAvailability as { ccr?: boolean })?.ccr ?? false;

  const isLoadingData = useMemo(
    () => isLoadingUser || isLoadingUserPreferences || !currentAccess.tenant,
    [isLoadingUser, isLoadingUserPreferences, currentAccess],
  );

  useEffect(() => {
    if (isLearner && !isCCREnabled) {
      navigate(ROUTES.LANDING);
    }
  }, [isLearner, isCCREnabled, isLoadingData, navigate]);

  if (isLoadingData) return <PageLoader />;

  if (isLearner && isCCREnabled) {
    return <LearnerLandingCCREnabled userData={userData} />;
  }

  if (!isLearner && isCCREnabled) {
    return <NonLearnerLandingCCREnabled />;
  }

  if (!isLearner && !isCCREnabled) {
    return <NonLearnerLandingCCRDisabled />;
  }

  return null;
};
